import React, { useMemo } from "react";
import { Box, Typography, useMediaQuery } from "@mui/material";
import { FormattedMessage } from "react-intl";
import { useSelector } from "react-redux";
import FileDropzone from "bundles/common/components/FileDropzone";

const StepResume = ({ values, errors, setErrors, resume, setResume }) => {
  const currentCandidate = useSelector((state) => state.current_candidate);
  const isMobile = useMediaQuery("(max-width:899px)");
  // Stable identity: FileDropzone resets its displayed file whenever the
  // initialFiles reference changes, so a fresh [] every render wiped the
  // just-imported CV on each parent re-render.
  const initialFiles = useMemo(
    () => (values.resume_url ? [values.resume_url] : []),
    [values.resume_url]
  );

  return (
    <Box id="ob-field-resume_url" sx={{ display: "flex", flexDirection: "column", gap: "1.5rem" }}>
      <Typography
        sx={{
          fontFamily: "'Segoe UI Semibold', system-ui, sans-serif",
          fontSize: "1rem",
          color: "hsl(222.2, 84%, 4.9%)",
        }}
      >
        <FormattedMessage id="onboarding.resume" />
      </Typography>
      <FileDropzone
        handleFileInput={(file) => {
          if (!resume || file.length !== resume.length) {
            setResume(file);
            setErrors((prev) => ({ ...prev, resume: "", resume_url: "" }));
          }
        }}
        filesLimit={1}
        dropzoneTextId={isMobile ? "onboarding.upload_cv_mobile" : "devise.signup.drag_and_drop_zone"}
        initialFiles={initialFiles}
        fileName={`${currentCandidate.first_name} ${currentCandidate.last_name} - CV`}
        type="candidate"
      />
      {errors.resume_url && (
        <Typography sx={{ color: "hsl(0, 84.2%, 60.2%)", fontSize: "0.75rem", mt: "-0.5rem" }}>
          {errors.resume_url}
        </Typography>
      )}
    </Box>
  );
};

export default StepResume;
